<template>
    <div>
      <Layout ref="layoutRef" :selectedOption="1"/>
      <div class="breadcrumb-container">
        <router-link to="/atencion">Atenciones</router-link> >
        <router-link :to="'/atencionform/' + p_idAtencion ">Atención {{ p_numero }}</router-link> 
        > Tratamiento
      </div>
      <hr />
      <div v-if="tratamiento">
        <h5>Información General del Tratamiento</h5>
        <p><strong>Observación:</strong> {{ tratamiento.observacion }}</p>
      </div>
  
      <br>
      <div v-if="pedidoImagen">
        <h5>Pedido de Imágenes</h5>
        <p><strong>Observación:</strong> {{ pedidoImagen.observacion }}</p>
        <table>
          <thead>
            <tr>
              <th>Examen Nombre</th>
              <th>Observación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="detalle in detallesImagenFiltrados" :key="detalle.idPedidoDet">
              <td>{{ detalle.examenNombre }}</td>
              <td>{{ detalle.observacion }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <br>
      <div v-if="pedidoLaboratorio">
        <h5>Pedido de Laboratorio</h5>
        <p><strong>Observación:</strong> {{ pedidoLaboratorio.observacion }}</p>
        <table>
          <thead>
            <tr>
              <th>Examen Nombre</th>
              <th>Observación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="detalle in detallesLaboratorioFiltrados" :key="detalle.idPedidoDet">
              <td>{{ detalle.examenNombre }}</td>
              <td>{{ detalle.observacion }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <br>
      <div v-if="receta">
        <h5>Medicamentos</h5>
        <p><strong>Observación:</strong> {{ receta.observacion }}</p>
        <table>
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre del Medicamento</th>
              <th>indicación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="detalle in detallesReceta" :key="detalle.idPedidoDet">
              <td>{{ detalle.elementoCodigo }}</td>
              <td>{{ detalle.elementoNombre }}</td>
              <td>{{ detalle.indicacion }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <Footer />
    </div>
  </template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import api from "@/services/api";
export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      tratamiento: null,
      pedidoImagen: null,
      detallesImagen: [],
      pedidoLaboratorio: null,
      detallesLaboratorio: [],
      receta: null,
      detallesReceta: [],
      p_idAtencion: null
    };
  },
  computed: {
    detallesImagenFiltrados() {
      return this.detallesImagen.filter(detalle => detalle.estado === 1);
    },
    detallesLaboratorioFiltrados() {
      return this.detallesLaboratorio.filter(detalle => detalle.estado === 1);
    }
  },
  async mounted() {
    this.p_idAtencion = this.$route.params.p_idatencion;
    await this.cargarDatos();
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods: {
    async cargarDatos() {
      try {
        const resTratamiento = await api.get(`/vwtratamientos/idatencion/${this.p_idAtencion}`);
        this.tratamiento = resTratamiento.data;

        const resImagen = await api.get(`/vwpedidos/idatencion-tipo/${this.p_idAtencion}/I`);
        this.pedidoImagen = resImagen.data;
        const detallesImagen = await api.get(`/vwpedidodets/idpedido/${resImagen.data.idPedido}`);
        this.detallesImagen = detallesImagen.data;

        const resLaboratorio = await api.get(`/vwpedidos/idatencion-tipo/${this.p_idAtencion}/L`);
        this.pedidoLaboratorio = resLaboratorio.data;
        const detallesLaboratorio = await api.get(`/vwpedidodets/idpedido/${resLaboratorio.data.idPedido}`);
        this.detallesLaboratorio = detallesLaboratorio.data;

        const resMedicamento = await api.get(`/vwrecetas/idatencion/${this.p_idAtencion}`);
        this.receta = resMedicamento.data;
        const detallesReceta = await api.get(`/vwrecetadets/idreceta/${resMedicamento.data.idReceta}`);
        this.detallesReceta = detallesReceta.data;
        
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    }
  }
};
</script>
<style scoped>
table {
  width: 100%; /* Ocupa el ancho completo de su contenedor */
  border-collapse: collapse; /* Colapsa los bordes de la tabla */
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1); /* Sombra suave alrededor de la tabla */
  background-color: #ffffff; /* Fondo blanco para la tabla */
  margin-top: 20px; /* Margen superior */
}

th, td {
  text-align: left; /* Alineación de texto a la izquierda */
  padding: 12px 15px; /* Espaciado interno */
  border-bottom: 1px solid #dddddd; /* Borde inferior de cada celda */
}

th {
  background-color: #009879; /* Color de fondo para los encabezados */
  color: #ffffff; /* Color de texto para los encabezados */
  font-weight: bold; /* Fuente en negrita para los encabezados */
}

tr:nth-child(even) {
  background-color: #f3f3f3; /* Color de fondo para las filas pares */
}

tr:hover {
  background-color: #f5f5f5; /* Color de fondo al pasar el mouse sobre una fila */
  cursor: pointer; /* Cambia el cursor a pointer */
}
</style>
